
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"39","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 12C0 5.373 5.373 0 12 0h26.95v29.295a4 4 0 01-4 4H0V12z","fill":"#FFFEFE"}}),_c('path',{attrs:{"d":"M30.495 9.345H8.345c-1.125 0-2.064.926-2.064 2.037V25.27c0 1.11.939 2.037 2.065 2.037h22.243c1.126 0 2.065-.926 2.065-2.037V11.382c-.094-1.111-1.033-2.037-2.16-2.037zM19.42 25.825c-4.223 0-7.602-3.333-7.602-7.5 0-4.166 3.379-7.499 7.602-7.499 4.224 0 7.602 3.333 7.602 7.5 0 4.166-3.378 7.498-7.602 7.498zm10.324-12.406h-1.032a1.035 1.035 0 01-1.033-1.019c0-.555.47-1.018 1.033-1.018h1.032c.563 0 1.033.463 1.033 1.018 0 .556-.47 1.019-1.033 1.019z","fill":"#8DC540"}}),_c('path',{attrs:{"d":"M22.704 5.026h-4.43c-1.038 0-1.98.69-2.263 1.677l-1.32 3.552h11.595l-1.32-3.552c-.377-.987-1.32-1.677-2.262-1.677zM11.457 7.981H9.97c-.594 0-1.189.38-1.189.91h3.865c0-.53-.496-.91-1.19-.91zm3.755 10.869a4.196 4.196 0 014.11-4.673V13.05c0-.062.078-.096.129-.058l2.317 1.703c.038.03.038.088 0 .114l-2.315 1.703c-.053.038-.13.005-.13-.058V15.33a3.034 3.034 0 00-2.978 3.187c.033.648.277 1.245.66 1.727a.577.577 0 01-.109.827.581.581 0 01-.8-.111 4.132 4.132 0 01-.884-2.11zm6.69-2.163a2.987 2.987 0 01.427 3.055 3.03 3.03 0 01-2.744 1.86v-1.125c0-.063-.079-.096-.13-.058l-2.317 1.703a.07.07 0 000 .114l2.315 1.703c.053.038.13.004.13-.058v-1.127a4.188 4.188 0 004.109-4.673 4.109 4.109 0 00-.883-2.11.581.581 0 00-.8-.11.578.578 0 00-.107.826z","fill":"#8DC540"}})])
          )
        }
      }
    